export const regionLocalStorageKey = "selectedRegion";
export const tokenLocalStorageKey = "token";
export const tenantLocalStorageKey = "tenant";
export const refreshTokenLocalStorageKey = "refreshToken";

export const spaceClientId = "624ad76a8c3e5a0d98237181";

export const regionDataArray = [
  { key: "au", text: "Australia", url: process.env.OUTLOOK_API_URL_AU || "https://au-api.ricohspaces.app" },
  {
    key: "eu",
    text: "Europe",
    url: process.env.OUTLOOK_API_URL_EU || "https://eu-api.ricohspaces.app",
  },
  { key: "us", text: "United States", url: process.env.OUTLOOK_API_URL_US || "https://us-api.ricohspaces.app" },
];
